import Restriction from './services/restriction';
import Config from './services/config';
import PlayerSrv from './services/playerSrv';
import Logger from './logger';
import PostersManager from './services/postersManager';
import pallyCon from './plugins/pallyConFairplay';
import Analytics from './plugins/analytics';
import vimmiPI from './plugins/vimmiPI';
import vjsSrv from './services/vjsSrv';
import Preview from './services/preview';
import ads from './plugins/ads';
import autoplayState from './services/autoplayState';
import eventsSrv from 'src/js/services/events';
import { normalizeLang } from 'vimmi-web-utils/cjs/normalizeLang';
import { PLAYER_EVENTS } from 'vimmi-web-utils/cjs/postMessage';
import $logger from './logger';

let vimmiPISubscribers = [];

export default class PlayerWrapper {
  constructor() {
    this.registerModuleListeners();
    eventsSrv.on('_internal-play', ({ asset, isFullAsset }) => {
      this.play(asset, isFullAsset);
    });
  }

  registerModuleListeners() {
    vimmiPISubscribers.push(
      vimmiPI.on('playback_created', (event, createdPlaybackItem) => {
        if (!vjsSrv.vjsPlayer) {
          return;
        }

        $logger.p('vimmiPI/playback_created').debug(createdPlaybackItem);
        vimmiPI.getActiveAsset().set('extraData.errorHandlerTimeoutId', null);
        vimmiPI.getActiveAsset().set('extraData.appliedPrefLang', false);
        this.setPlayerPlaybackItem(createdPlaybackItem, vimmiPI.getActiveAsset().get('playerOptions.autoplay'));
        /** todo: example of "createdPlaybackItem"*/
        // {
        //     priority: number
        //     serverId?: string
        //     mimeType?: string,
        //     cdn?: string
        //     drm?: {
        //         certificate: string,
        //         content: string,
        //         license: string,
        //         type?: string
        //     },
        //     url?: string
        // }

      }));


    vimmiPISubscribers.push(vimmiPI.on('playback_updated', (event, updatedPlaybackItem) => {
      if (!vjsSrv.vjsPlayer) {
        return;
      }
      // if (ads.withAds && ads.playing()) {
      //   vjsSrv.vjsPlayer.hasStarted(true); // to prevent call play in contrib-ads plugin
      // }

      $logger.p('vimmiPI/playback_updated').debug(updatedPlaybackItem);
      vimmiPI.getActiveAsset().set('extraData.errorHandlerTimeoutId', null);
      vimmiPI.getActiveAsset().set('extraData.appliedPrefLang', false);
      this.setPlayerPlaybackItem(updatedPlaybackItem, vimmiPI.getActiveAsset().get('playerOptions.autoplay'), true);
      /** todo: example of "updatedPlaybackItem"*/
      // {
      //     priority: number
      //     serverId?: string
      //     mimeType?: string,
      //     cdn?: string
      //     drm?: {
      //         certificate: string,
      //         content: string,
      //         license: string,
      //         type?: string
      //     },
      //     url?: string
      // }
    }));

    vimmiPISubscribers.push(vimmiPI.on('playback_error', (event, error) => {
      if (!vjsSrv.vjsPlayer) {
        return;
      }
      $logger.p('vimmiPI/playback_error').error(error);
      vimmiPI.getActiveAsset().set('extraData.errorHandlerTimeoutId', null);
      vjsSrv.resetPlayer().then(() => {
        PostersManager.setCurrentPoster(vimmiPI.getActiveAsset());
        vjsSrv.vjsPlayer.internalError = error;
        vjsSrv.vjsPlayer.error({
          message: vjsSrv.vjsPlayer.localize('Something went wrong, the player cannot continue playback!'), //error.message,
          code: error.code > 5 ? 0 : error.code
        });
        vjsSrv.vjsPlayer.errorDisplay.show();
      });
    }));

    vimmiPISubscribers.push(vimmiPI.on('concurrency_state', (state) => {
      if (!vjsSrv.vjsPlayer) {
        return;
      }

      eventsSrv.emit(PLAYER_EVENTS.CONCURRENCY, {
        stream_time: vimmiPI.getActiveAsset().get('extraData.stream_time'),
        id: vimmiPI.getActiveAsset().get('item.id'),
        restricted: vimmiPI.getActiveAsset().get('restricted'),
        state: state
      });

      if (Restriction.isRestricted(vimmiPI.getActiveAsset())) {
        Restriction.show(vimmiPI.getActiveAsset());
      } else {
        Restriction.hide();
      }
      $logger.p('vimmiPI/concurrency_state').debug(state);
    }));
  }

  applyStartPosition() {
    if (!vimmiPI.getActiveAsset().get('playerOptions.startPosition')) {
      vimmiPI.getActiveAsset().set('state.changingAudio', null)
      return;
    }

    if (Preview.isShowPreview(vimmiPI.getActiveAsset())) {
      // Preview.activated(true);
      if (vimmiPI.getActiveAsset().get('state.changingAudio')) {
        vjsSrv.vjsPlayer.currentTime(vimmiPI.getActiveAsset().get('playerOptions.startPosition'));
        vimmiPI.getActiveAsset().set('state.changingAudio', null);
      } else {
        let previewInfo = vimmiPI.getActiveAsset().get('preview_info');
        vjsSrv.vjsPlayer.currentTime(previewInfo.preview_start);
      }
      vimmiPI.getActiveAsset().set('playerOptions.startPosition', null);

    } else if (vimmiPI.getActiveAsset().get('playerOptions.startPosition') && ((vjsSrv.vjsPlayer.duration() - vimmiPI.getActiveAsset().get('playerOptions.startPosition')) > 1) && (Config.get('eventsState.loadeddata') || Config.get('eventsState.loadedmetadata'))) {
      vjsSrv.vjsPlayer.currentTime(vimmiPI.getActiveAsset().get('playerOptions.startPosition'));

      $logger.p('applyStartPosition').log('moved to position:', vimmiPI.getActiveAsset().get('playerOptions.startPosition'));
      if (vimmiPI.getActiveAsset().get('state.changingAudio')) {
        vimmiPI.getActiveAsset().set('state.changingAudio', null);
      }
      vimmiPI.getActiveAsset().set('playerOptions.startPosition', null);
    }
  }

  /**
   * @param asset {Object} the video asset  //todo:
   * @param isFullAsset {Boolean}
   *
   * */
  async play(asset, isFullAsset = true) {
    Config.set('eventsState.sourceChanging', true);
    /** if previous video not restricted */
    if (vimmiPI.getActiveAsset() && !Config.get('eventsState.ended') && !Config.get('eventsState.error') && Config.get('eventsState.started') && !Restriction.isRestricted(vimmiPI.getActiveAsset())) {
      Analytics.send('chu', {}, {
        force: true,
        asset: vimmiPI.getActiveAsset()
      });
      Analytics.send('stop', {
        stop_cause: 'switch'
      }, {
        asset: vimmiPI.getActiveAsset()
      });
    }

    Restriction.reset();
    if (vjsSrv.vjsPlayer.error()) {
      vjsSrv.vjsPlayer.error(null);
    }
    if (Restriction.isRestricted(asset)) {
      await vjsSrv.resetPlayer();
      Config.set('eventsState', {
        isStartPlay: false,
        isCallPlay: Config.get('eventsState.isCallPlay'),
        prevUserActiveState: false,
        loadstart: false,
        waiting: false,
        loadedmetadata: false,
        loadeddata: false,
        playing: false,
        ended: false,
        error: false
      });
      vjsSrv.vjsPlayer.reset();
      PostersManager.setCurrentPoster(asset);
      Restriction.show(asset);
      vjsSrv.vjsPlayer.removeClass('custom-waiting-video');
      return;
    } else {
      Restriction.hide(asset);
      PostersManager.setCurrentPoster(asset);
    }

    vjsSrv.vjsPlayer.addClass('custom-waiting-video');

    if (vimmiPI.getActiveAsset()) {
      PlayerSrv.prevAsset = vimmiPI.getActiveAsset();
    }

    asset.extraData.first_byte_start = Date.now();
    const prevVideoLang = PlayerSrv.prevAsset ? PlayerSrv.prevAsset.get('metadataLang') : null;
    asset.metadataLang = normalizeLang((Config.get('platform') !=='stv' && prevVideoLang) || Config.get('params.portal.preferred_audio_lang') || 'th', 'iso-2');
    if (isFullAsset) {
      asset.set('extraData.delay_start', Date.now());
      vimmiPI.applyAsset(asset);
      this.preparePlayer(asset);
    } else {
      asset.extraData.click_to_media_start = asset.extraData.click_to_media_start || Date.now();
      let method = 'getByMediaId';
      if (asset.mediaStream) {
        method = 'getByMediaStream';
      } else if (asset.playback_url) {
        method = asset.playback_url.indexOf('/metadata.') !== -1 ? 'getByMetadataUrl' : 'getByPlaybackUrl';
      } else if (asset.alphaId && !asset.drm) {
        method = 'getByMetadataUrl';
      }

      vimmiPI[method](asset, true, !(!!asset.preview)).then((fullAsset) => {
        if (!vjsSrv.vjsPlayer) {// player destroyed
          return;
        }
        if (fullAsset) {
          fullAsset.set('extraData.delay_start', Date.now());
          fullAsset.set('extraData.click_to_media_end', Date.now());
          this.preparePlayer(fullAsset);
        }
      }).catch((error) => {
        if (!vjsSrv.vjsPlayer) {// player destroyed
          return;
        }
        $logger.p(`vimmiPI/${method}`).error(error);
        vjsSrv.resetPlayer().then(() => {
          PostersManager.setCurrentPoster(asset);
          error.finalError = true;
          vjsSrv.vjsPlayer.internalError = error;
          vjsSrv.vjsPlayer.error({
            message: vjsSrv.vjsPlayer.localize('Something went wrong, the player cannot continue playback!'), // error.name || error.message,
            code: error.code > 5 ? 0 : error.code
          });
          vjsSrv.vjsPlayer.errorDisplay.show();
        });
      });
    }
    // });
  }

  async setPlayerPlaybackItem(playbackItem, autoplay = true, isUpdate = false) {

    let asset = vimmiPI.getActiveAsset();
    if (asset.get('state.changingAudio')) {
      asset.set('extraData.missedBytes', asset.get('extraData.missedBytes', 0) + asset.get('extraData.bytes', 0));
    }
    let videoJsSource = PlayerSrv.getVideoJsSrc(playbackItem, vimmiPI.getActiveAsset());

    let adsWithAutoplay = false;
    vjsSrv.vjsPlayer.autoplay(false);

    let autoplayBrowserAllow = await vjsSrv.autoplayBrowserAllow();
    let mutedAutoplayBrowserAllow = await vjsSrv.mutedAutoplayBrowserAllow();

    if (autoplayBrowserAllow || mutedAutoplayBrowserAllow) {
      adsWithAutoplay = true;
    }

    if (!isUpdate) {
      if (!asset.adsPreloaded && ads.isAdInit) {
        await ads.clear();
      }
      await vjsSrv.resetPlayer();

      vjsSrv.vjsPlayer.TechSrv.handleAspectRatioByItem(asset);
      if (asset.playerOptions.controls) {
        vjsSrv.controls(true);
      } else if (asset.playerOptions.controls === false) {
        vjsSrv.controls(false);
      }

      if (asset.preview) {
        Preview.show(asset);
      } else {
        Preview.hide();
      }

      if (!asset.adsPreloaded && !asset.preview) {
        if ((asset.adTag || asset.adVast) && !Restriction.isRestricted(asset)) {
          await ads.handleAds({
            adTag: asset.adTag,
            adVast: asset.adVast
          }, asset.adVolume, adsWithAutoplay, asset.isLive);
        }
      }
    }
    // if (ads.isBuggedIos && ads.withAds && !ads.isAdDisplayContainerInit) {
    //   Config.set('eventsState.isCallPlay', false);
    // }
    if (playbackItem.drm && asset.origin === 'anevia' && playbackItem.drm.type === 'HLS/FAIRPLAY') {
      let origFN = pallyCon.onCertificateLoaded;
      pallyCon.onCertificateLoaded = function(event) {
        origFN(event);
        vjsSrv.vjsPlayer.load();
      };
      pallyCon.fairplay({
        license_url: videoJsSource.keySystems[Config.get('keySystems')[playbackItem.drm.type]].licenseUri,
        player: vjsSrv.vjsPlayer,
        pallycon_custom_data: playbackItem.drm.token,
        certificate_uri: videoJsSource.keySystems[Config.get('keySystems')[playbackItem.drm.type]].certificateUri,
        content_url: videoJsSource.src
      });
      $logger.p('pallyCon/init').debug(videoJsSource);

    } else {
      if (videoJsSource.srcObject) {
        vjsSrv.vjsPlayer.src('/assets/blank.mp4'); // need for properly initialize the player first time
        vjsSrv.vjsPlayer.tech(true).el().srcObject = videoJsSource.srcObject;
      } else {
        vjsSrv.vjsPlayer
          .src(videoJsSource);
      }

      $logger.p('setSource').debug(videoJsSource);
      vjsSrv.vjsPlayer.load();
    }
    if (!isUpdate) {
      if (asset.get('playerOptions.muted') || (autoplay && !autoplayBrowserAllow && asset.get('playerOptions.forceAutoplayMuted'))) {
        vjsSrv.vjsPlayer.muted(true);
        vjsSrv.vjsPlayer.volume(0);
      } else if (vjsSrv.vjsPlayer.muted() && !autoplayBrowserAllow) { // need only first time (during first play)
        vjsSrv.vjsPlayer.muted(false);
      }
      if (autoplay || Config.get('eventsState.isCallPlay')) {
        vjsSrv.tryPlay();
      }
    } else if (asset.get('state.changingAudio') && !asset.get('state.pause')) {
      vjsSrv.tryPlay();
    }
  }

  /**
   * @method preparePlayer
   * @param {Object} asset - media asset
   * @description make preparation to start play new video
   * */
  preparePlayer(asset) {

    if (asset.isLive) {
      vjsSrv.vjsPlayer.addClass('vjs-v-live');
    } else {
      vjsSrv.vjsPlayer.removeClass('vjs-v-live');
    }


    Config.set('eventsState', {
      isStartPlay: false,
      isCallPlay: Config.get('eventsState.isCallPlay'),
      prevUserActiveState: false,
      loadstart: false,
      waiting: false,
      loadedmetadata: false,
      loadeddata: false,
      playing: false,
      ended: false,
      error: false
    });

    vjsSrv.vjsPlayer.internalError = null;

    Analytics.beforePlay(asset);
    /** seams the part not used, need to check it */
    if (Config.get('params.controls')) {
      vjsSrv.controls(true);
    }

    vjsSrv.vjsPlayer.removeClass('empty-player');
    vjsSrv.vjsPlayer.removeClass('vjs-error');

    //TODO: need to handle this options in other place
    if (asset.playerOptions.mainPage) {
      vjsSrv.vjsPlayer.addClass('vjs-main-player');
    } else {
      vjsSrv.vjsPlayer.removeClass('vjs-main-player');
    }
    if (vjsSrv.vjsPlayer.WrapperBigPlayBtn) {
      if (!asset.playerOptions.bigButton && asset.playerOptions.bigButton !== undefined) {
        vjsSrv.vjsPlayer.WrapperBigPlayBtn.hide();
      } else {
        vjsSrv.vjsPlayer.WrapperBigPlayBtn.show();
      }
    }

    if (vjsSrv.vjsPlayer.controlBar.NextButton) {
      vjsSrv.vjsPlayer.controlBar.NextButton.disable();
    }
    if (vjsSrv.vjsPlayer.controlBar.PrevButton) {
      vjsSrv.vjsPlayer.controlBar.PrevButton.disable();
    }
    // EmbeddedCodeSrv.toggle(asset.playerOptions.showEmbedded);
  }

  destroy() {
    vimmiPI.off(vimmiPISubscribers);
    vimmiPISubscribers = [];
  }
}
